import {create} from "zustand";
import {Shop, SHOP_TYPE, ShopType} from "./types";
import type {ShopRepository} from "../model/repository";

type CreateShopStoreParams = {
    repository: ShopRepository;
};

export type StoreState = {
    shops: Shop[];
    shopType: ShopType;
    query: string;
    loading: boolean;
    error: unknown | null;

    actions: {
        fetchShops: () => Promise<void>;
        changeShopType: (shopType: ShopType) => void;
        setQuery: (query: string) => void;
    };
};

export const createShopStore = (
    {
        repository,
    }: CreateShopStoreParams
) => create<StoreState>((set, get) => ({
    shops: [],
    shopType: SHOP_TYPE.BRANDED,
    query: "",
    loading: false,
    error: null,

    actions: {
        fetchShops: async () => {
            set({loading: true, error: null});

            try {
                const shops = await repository.getShops({
                    shopType: get().shopType,
                    query: get().query,
                });

                set({shops});
            } catch (error) {
                set({error});
            } finally {
                set({loading: false});
            }
        },

        changeShopType: (shopType) => {
            set({shopType});
        },

        setQuery: (query) => {
            set({query});
        },
    },
}));
